// extracted by mini-css-extract-plugin
export var career__text = "Career-module--career__text--1BjDu";